export interface Variables {
  BORDER_RADIUS: string;
}

export default {
  BORDER_RADIUS: '4px',
} as Variables;
